<!DOCTYPE html>
<html lang="de" data-theme="Code vibes theme">

<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Memory</title>
  <link rel="icon" type="image/svg+xml" href="/img/stadia-controller.svg">
</head>

<body class="start-screen">
  <img src="/img/stadia-controller.png" alt="" aria-hidden="true">
  <main>
    <div class="start-screen-content">
      <p class="sub-headline">It’s play time.</p>
      <h1>Ready to Play?</h1>
      <div class="start-screen-buttons">
        <a href="./src/subpages/settings.html" class="button start-screen-button">
          <img class="button-icons --controller" src="/img/stadia-controller.svg" alt="" aria-hidden="true">
          <span class="start-screen-button__label">Play</span>
          <img class="button-icons --arrow" src="/img/arrow-1.svg" alt="" aria-hidden="true">
        </a>
      </div>
    </div>
  </main>
  <script type="module" src="/src/main.ts"></script>
</body>

</html>
